import React from 'react';
import styled from '@emotion/styled/macro';
import { InputLabelAtom } from '../../atoms/text-atoms/text-atoms';

const CheckboxInput = ({
  id,
  label,
  selectedCheckboxes,
  handleChange,
  isInset = false,
  isBold = false,
  dataGroupId,
  className,
}) => {
  return (
    <div className={`${className} input-element`}>
      <InputLabelAtom isInset={isInset} isBold={isBold}>
        <input
          type="checkbox"
          id={id}
          checked={selectedCheckboxes.includes(id)}
          onChange={handleChange}
          data-group-id={dataGroupId}
          data-testid="filter-checkbox"
        />
        <span>{label}</span>
      </InputLabelAtom>
    </div>
  );
};

// === CheckboxInput CSS ===
const StyledCheckboxInput = styled(CheckboxInput)`
  ${InputLabelAtom}:hover, input:hover {
    cursor: pointer;
  }
`;

export default StyledCheckboxInput;
